export interface QAAccessContext {
  qaEnabled: boolean;
  canAccessQa: boolean;
  isSystemSession: boolean;
}

export const canAccessQA = (ctx: QAAccessContext): boolean =>
  ctx.qaEnabled && (ctx.canAccessQa || ctx.isSystemSession);
